import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import axios from "../utils/Axios"; // Ensure axios is imported correctly
import { BeatLoader } from "react-spinners";

const Login = () => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const validateForm = () => {
    const { username, password } = formData;
    const newErrors = {};

    if (!username || !username.includes("@")) {
      newErrors.username = "Please enter a valid email address.";
    }

    // if (password && password.length < 8) {
    //   newErrors.password = "Password must be at least 8 characters.";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    setLoading(true);
    const { username, password } = formData;
    try {
      const response = await axios.post("/login", {
        email: username,
        password,
      });

      if (response.status === 200) {
        const token = response.data.token;
        localStorage.setItem("token", token);
        localStorage.setItem("username", localStorage.setItem("User_info", JSON.stringify(response.data)));
        toast.success(response.data.message);
        window.location.reload();
        navigate("/");
      }

    } catch (error) {
      console.log('Error while logging in:', error);
      toast.error(error.response?.data?.error || "Failed to log in.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-r from-green-200 via-yellow-200 to-brown-200">
        <div className="relative w-full  max-w-md bg-white p-8 rounded-md shadow-md">
          <h1 className="text-2xl font-bold text-center mb-6">
            <span className="text-gray-700">Login with</span>{" "}
            <span className="text-green-600">Katyayani Organics</span>
          </h1>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Email Field */}
            <div>
              <label
                htmlFor="username"
                className="block font-semibold text-gray-600 mb-1"
              >
                Email
              </label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className={`w-full px-4 py-3 border rounded-md ${errors.username
                  ? "border-red-500 focus:border-red-600"
                  : "border-green-400 focus:border-green-600"
                  }`}
                placeholder="Enter your email"
              />
              {errors.username && (
                <p className="text-sm text-red-500 mt-1">{errors.username}</p>
              )}
            </div>

            {/* Password Field */}
            <div>
              <label
                htmlFor="password"
                className="block font-semibold text-gray-600 mb-1"
              >
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className={`w-full px-4 py-3 border rounded-md ${errors.password
                    ? "border-red-500 focus:border-red-600"
                    : "border-green-400 focus:border-green-600"
                    }`}
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-4 text-gray-600"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
              {errors.password && (
                <p className="text-sm text-red-500 mt-1">{errors.password}</p>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className={`w-full px-4 py-3 text-white rounded-md font-semibold transition ${loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-green-500 hover:bg-green-600"
                }`}
            >
              {loading ? (
                <div className="flex justify-center items-center gap-2">
                  <BeatLoader size={8} color="#fff" />
                  <span>Logging in...</span>
                </div>
              ) : (
                "Login"
              )}
            </button>

            {/* General Error */}
            {errors.general && (
              <p className="text-sm text-red-500 text-center mt-2">
                {errors.general}
              </p>
            )}

            {/* Links */}
            {/* <div className="flex justify-between mt-4 text-sm text-gray-600">
            <Link to="/verify-email" className="hover:text-green-700">
              Verify Email
            </Link>
            <Link to="/resetpassword" className="hover:text-green-700">
              Forgot Password?
            </Link>
          </div> */}

            <div className="text-center mt-6 text-sm">
              <span>Don't have an account?</span>{" "}
              <Link
                to="/register"
                className="text-green-600 font-semibold hover:text-green-700"
              >
                Sign Up
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
